'use strict';
var r = window.__planday_app_registry__, p = window.__planday_public_path__;
__webpack_public_path__ =
  r && r['planday.signup/index'] ? r['planday.signup/index'].p :
  p ? p : '/'